import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { fmtIST, FAMILY_LABEL } from "@/lib/useApi";

function parts(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

export function Countdown({ item, offset = 0 }) {
  const [t, setT] = useState(Date.now() + offset);
  useEffect(() => {
    const i = setInterval(() => setT(Date.now() + offset), 1000);
    return () => clearInterval(i);
  }, [offset]);
  const a = item.announcement;
  const fam = FAMILY_LABEL[item.family];
  if (!a)
    return (
      <div className="p-5 rounded-xl border border-slate-200 bg-white" data-testid={`countdown-${item.family}`}>
        <p className="text-xs uppercase tracking-wider text-slate-500 font-medium">{fam}</p>
        <p className="mt-2 text-sm text-slate-700" data-testid={`countdown-${item.family}-not-announced`}>{item.message}</p>
      </div>
    );
  const start = Date.parse(a.exam_start), end = Date.parse(a.exam_end);
  const live = t >= start && t <= end;
  const p = parts(start - t);
  return (
    <div className="p-5 rounded-xl border border-slate-200 bg-white" data-testid={`countdown-${item.family}`}>
      <div className="flex items-center justify-between">
        <p className="text-xs uppercase tracking-wider text-slate-500 font-medium">{fam} · {a.cycle}</p>
        <CalendarClock className="h-4 w-4 text-blue-600" />
      </div>
      {live ? (
        <p className="mt-2 font-display font-bold text-xl text-emerald-700">Examination window in progress</p>
      ) : (
        <p className="mt-2 font-mono text-2xl text-slate-900" data-testid={`countdown-${item.family}-timer`}>
          {p.d}d {String(p.h).padStart(2, "0")}h {String(p.m).padStart(2, "0")}m {String(p.s).padStart(2, "0")}s
        </p>
      )}
      <p className="text-xs text-slate-500 mt-2">Starts {fmtIST(a.exam_start)}</p>
      {a.source_url && (
        <a href={a.source_url} target="_blank" rel="noreferrer" className="text-xs text-blue-600 hover:underline">Official source</a>
      )}
    </div>
  );
}
